import { useState } from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDSelect from "components/MDSelect";
import DataTable from "components/DataTable";
import ReactPaginate from "react-paginate";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const AdvanceTable = ({
  columns,
  rows,
  filters = [],
  pagination,
  onPageChange,
  totalElements,
}) => {
  // Local state for filter values
  const [localFilters, setLocalFilters] = useState(
    filters.reduce((acc, filter) => {
      acc[filter.key] = String(filter.value || "");
      return acc;
    }, {})
  );

  const renderFilter = (filter, index) => {
    switch (filter.type) {
      case "text":
        return (
          <MDInput
            type="text"
            key={filter.key}
            className="input input-search input-search-text"
            placeholder={filter.label}
            onChange={filter.onChange}
            startAdornment={filter.startAdornment}
            endAdornment={filter.endAdornment}
            {...filter.props}
          />
        );
      case "select":
        return (
          <MDSelect
            key={index}
            className="input input-search input-search-select"
            options={[
              { value: "", label: `Select ${filter.label}` },
              ...filter.options,
            ]}
            value={
              filter.options.find(
                (item) => item.value === localFilters[filter.key]
              ) || {
                value: "",
                label: `Select ${filter.label}`,
              }
            }
            placeholder={filter.placeholder}
            onChange={filter.onChange}
            startAdornment={filter.startAdornment}
            endAdornment={filter.endAdornment}
            {...filter.props}
          />
        );
      case "datepicker":
        return (
          <DatePicker
            key={index}
            label={filter.label}
            value={
              localFilters[filter.key]
                ? new Date(localFilters[filter.key])
                : null
            }
            placeholder={filter.placeholder}
            onChange={filter.onChange}
            startAdornment={filter.startAdornment}
            endAdornment={filter.endAdornment}
            {...filter.props}
          />
        );
      default:
        return null;
    }
  };

  const dataTableProps = {
    className: "table",
    table: { columns, rows },
    entriesPerPage: false,
    showTotalEntries: false,
    isSorted: false,
  };

  const showPagination =
    pagination &&
    typeof onPageChange === "function" &&
    typeof totalElements === "number";

  const paginationProps = {
    breakLabel: "...",
    nextLabel: <ChevronRight />,
    previousLabel: <ChevronLeft />,
    previousClassName: "paginate-general-task-item",
    nextClassName: "paginate-general-task-item",
    forcePage: pagination?.currentPage || 0,
    onPageChange: (event) => onPageChange?.(event.selected),
    pageRangeDisplayed: 1,
    pageCount: pagination?.totalPage || 0,
    renderOnZeroPageCount: null,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MDBox className="content-lxo-task">
        <MDBox className="group-filter">
          {filters.map((filter, index) => renderFilter(filter, index))}
        </MDBox>
        <MDBox className="group-table">
          <DataTable {...dataTableProps} />
          {showPagination && (
            <MDBox className="table-footer">
              <MDBox className="table-footer-showing">
                Showing {rows.length} of {totalElements} entries
              </MDBox>
              {totalElements > 0 && (
                <MDBox className="pagination">
                  <ReactPaginate {...paginationProps} />
                </MDBox>
              )}
            </MDBox>
          )}
        </MDBox>
      </MDBox>
    </LocalizationProvider>
  );
};

export default AdvanceTable;
